/** Pure KPI aggregation for Finance Workspace (no allocation math on FE). */
export function aggregateFinanceWorkspaceProfitKpi(
  applicationsExtended: Array<{ profit?: number | null; plannedProfit?: number | null }>
): { profitFact: number; profitPlan: number } {
  let profitFact = 0;
  let profitPlan = 0;
  for (const app of applicationsExtended) {
    profitFact += Number(app.profit ?? 0);
    profitPlan += Number(app.plannedProfit ?? 0);
  }
  return { profitFact, profitPlan };
}
